import styled from 'styled-components';

import { Heading } from '@techstyle/react-components';

import { desktop } from '../../styles';

interface SectionProps {
  desktopOnly?: boolean;
  imageBackground?: string;
}

export const Section = styled.div<SectionProps>`
  display: ${props => (props.desktopOnly ? 'none' : 'flex')};
  flex-direction: column;
  flex-grow: 1;
  align-items: center;

  ${desktop`
    display: flex;
    flex-basis: 50%;
  `}

  ${props =>
    props.imageBackground
      ? `background-image: url('${props.imageBackground}')`
      : `background-color: ${props.theme.colors.gray150}`};
  background-size: cover;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  gap: 24px;
  padding: 32px 16px;

  ${desktop`
    max-width: 60%;
    padding: 24px 0px;
  `}
`;

export const Title = styled(Heading).attrs({
  level: 2,
  align: 'center',
})`
  ${({ theme }) => theme.header.variants.h2.textStyles}
  color: ${({ theme, color }) => color ?? theme.colors.white}
`;

export const Subtitle = styled.p`
  ${({ theme }) => theme.subHeader.variants.subHeading4Uppercase.textStyles}
  color: ${({ theme, color }) => color ?? theme.colors.white};
  font-weight: 400;
  text-align: center;
  font-size: 12px;
`;
